import React, { useEffect } from 'react';
import intl from 'react-intl-universal';
import ThrottleButton from '@/components/Reservation/ThrottleButton';
import useCountDown from '@/hooks/useCountDown';

import styles from './index.module.scss';

interface IProps {
  onClick: () => void;
  value: number;
}

const Index: React.FC<IProps> = (props) => {
  const { value, onClick } = props;
  const [timeLeft, startCountDown] = useCountDown({});

  useEffect(() => {
    if (value) {
      startCountDown(60);
    }
  }, [value]);

  const isPending = timeLeft > 0;

  const handleClick = () => {
    if (isPending) return;
    onClick();
  };

  return (
    <ThrottleButton
      type="link"
      className={styles.SMSCodeButton}
      onClick={handleClick}
      disabled={isPending}
    >
      {isPending
        ? intl.get('cpm_phone_check_modal_left_seconds_send_again', { timeLeft })
        : intl.get('cpm_phone_check_modal_send_sms_code')}
    </ThrottleButton>
  );
};

export default Index;
